import React from "react";
import DataGrid, {
  Column,
  Paging,
  Selection,
  Pager,
  Toolbar,
  FilterRow,
  Item,
  Label,
} from "devextreme-react/data-grid";
import Form from "devextreme-react/form";
import { Button, SelectBox } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView } from "devextreme-react/scroll-view";
import { formatMessage } from "devextreme/localization";
import { handleExportExcel, axios } from "../../../common";
import PopupConfig from "../../../common/popup";
import { useScreenSize } from "../../../utils/media-query";
import notify from "devextreme/ui/notify";
import { resetUser } from "../../../api/auth";

function UserTableList({ user, dataGrid, middleware }) {
  const [selectedItemKeys, setSelectedItemKeys] = React.useState([]);
  const { isXSmall, isSmall } = useScreenSize();
  const [employeeOid, setEmployeeOid] = React.useState();
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [employee, setEmployee] = React.useState([]);

  React.useEffect(() => {
    handleFetch();
  }, []);

  const handleFetch = async () => {
    try {
      const { data } = await axios.get("Employee", {
        params: {
          $filter: "DateOut eq null",
          $select: "Oid,EmployeeCode,FullName",
        },
      });
      setEmployee(data.value);
    } catch (error) {
      notify(error);
    }
  };

  const handleDelete = () => {
    selectedItemKeys.forEach((key) => {
      user.store().remove(key);
    });
    setSelectedItemKeys({
      selectedItemKeys: [],
    });
    user.reload();
  };

  const handleSubmitPopup = async () => {
    const payload = {
      UserName: popupConfig.data.UserName,
      IsActive: popupConfig.data.IsActive,
      Remarks: popupConfig.data.Remarks,
      Employee: {
        Oid: employeeOid,
      },
    };
    switch (popupConfig.data.type) {
      case "edit":
        await axios.put(`User(${popupConfig.data.Oid})`, payload, {
          headers: {
            MappedState: 3,
          },
        });
        notify("Success", "success", 2000);
        handleClosePopup();
        user.reload();
        break;
      case "create":
        await axios.post("User", payload, {
          headers: {
            MappedState: 2,
          },
        });

        notify("Success", "success", 2000);
        handleClosePopup();
        user.reload();
        break;
      default:
        break;
    }
  };

  const renderPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        title={formatMessage("AddNewUser")}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <ScrollView width="100%" height="100%">
          <Form formData={popupConfig.data}>
            <Item itemType="group" colCount={2} colSpan={2}>
              <Item dataField="UserName" colSpan={2}>
                <Label text={formatMessage("UserName")} />
              </Item>
              <Item colSpan={2} dataField="Employee">
                <Label text={formatMessage("Employee")} />
                <SelectBox
                  valueExpr="Oid"
                  dataSource={employee}
                  value={employeeOid}
                  displayExpr={gridBoxDisplayExpr}
                  itemRender={gridBoxDisplayExpr}
                  onValueChanged={(e) => {
                    setEmployeeOid(e.value);
                  }}
                  searchEnabled={true}
                />
              </Item>
              <Item
                dataField="IsActive"
                editorType="dxCheckBox"
                editorOptions={{
                  // set default value is True

                  defaultValue: true,
                }}
              >
                <Label text={formatMessage("IsActive")} />
              </Item>
            </Item>
            <Item itemType="group" colCount={2} colSpan={2}>
              <Item dataField="Remarks" editorType="dxTextArea" colSpan={2}>
                <Label text={formatMessage("Remarks")} />
              </Item>
            </Item>
          </Form>
        </ScrollView>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          // disabled={selectedItemKeysPopup[0].Oid ? true : false}
          location="after"
          onClick={handleSubmitPopup}
          options={{
            icon: "save",
            type: "default",
            text: formatMessage("Save"),
            width: "200px",
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };
  const handleSelectChanged = ({ selectedRowKeys }) => {
    setSelectedItemKeys(selectedRowKeys);
  };
  const handleResetPassword = async (payload) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Are you sure you want to reset password?")) {
      const data = await resetUser({
        UserReqOid: payload.Oid,
        UserResetOid: payload.Oid,
      });
      if (!data) {
        notify("Reset password failed", "error", 2000);
        return;
      }
      notify("Reset password success", "success", 2000);
    }
  };
  function gridBoxDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }

  const renderActions = ({ data }) => {
    const newData = {
      ...data,
      type: "edit",
    };
    return (
      <div>
        <Button
          type="default"
          stylingMode="outlined"
          text="Edit"
          onClick={() => {
            setEmployeeOid(data.Employee.Oid);
            handleOpenPopup(newData);
          }}
          className="button-rounded mr-2"
        />
        <Button
          type="danger"
          stylingMode="outlined"
          text="Delete"
          // icon="close"
          className="button-rounded mr-2"
          onClick={() => dataGrid.current.instance.deleteRow(data.Oid)}
        />
        <Button
          type="default"
          stylingMode="outlined"
          text="Reset"
          // icon="close"
          className="button-rounded"
          onClick={() => handleResetPassword(data)}
        />
      </div>
    );
  };
  return (
    <div>
      {popupConfig.popupVisible && renderPopup()}
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        dataSource={user}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        columnResizingMode="widget"
        rowAlternationEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        columnAutoWidth={true}
        allowColumnResizing={true}
        alignment="center"
        onSelectionChanged={handleSelectChanged}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        {/* <Column type="buttons">
          <Button name="delete" />
          <Button name="save" />
        </Column> */}
        {middleware && middleware.WriteState && (
          <Column
            caption={formatMessage("Action")}
            cellRender={renderActions}
            alignment="center"
            hidingPriority={isXSmall ? 15 : false}
          />
        )}
        <Column dataField="UserName" caption={formatMessage("UserName")} />
        {/* <Column
          dataField="Employee.Oid"
          caption={formatMessage("FullName")}
        >
          <Lookup
            dataSource={employee}
            valueExpr="Oid"
            displayExpr={gridBoxDisplayExpr}
          />
        </Column> */}
        <Column
          dataField="Employee.FullName"
          caption={formatMessage("FullName")}
          allowEditing={false}
        />
        <Column
          dataField="Employee.DateOfBirth"
          caption={formatMessage("BirthDate")}
          dataType="date"
          allowEditing={false}
        />
        <Column
          dataField="Employee.Department.DepartmentName"
          caption={formatMessage("Department")}
          allowEditing={false}
        />
        <Column
          dataField="Employee.Position.PositionName"
          caption={formatMessage("Position")}
          allowEditing={false}
        />
        <Column
          dataField="Remarks"
          caption={formatMessage("Remarks")}
          editorType="dxTextArea"
          colSpan={2}
        />
        {/* Remark User */}
        <Column dataField="IsActive" caption={formatMessage("IsActive")} />
        <Toolbar>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            {middleware && middleware.DeleteState && (
              <Button
                onClick={handleDelete}
                icon="trash"
                className="mr-1"
                disabled={!selectedItemKeys.length}
                text={formatMessage("DeleteSelectedRecords")}
              />
            )}
            {middleware && middleware.ExportState && (
              <Button
                icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#384455"/></svg>`}
                text={formatMessage("Export")}
                onClick={() => handleExportExcel(dataGrid, "User")}
                className="mr-1"
              />
            )}
            <Button
              icon="revert"
              text={formatMessage("Refresh")}
              onClick={() => dataGrid.current.instance.refresh()}
              name="revertButton"
              className="mr-1"
            />
            {middleware && middleware.CreateState && (
              <Button
                icon="plus"
                text={formatMessage("NewUser")}
                onClick={() => {
                  setEmployeeOid();
                  handleOpenPopup({ type: "create" });
                }}
                stylingMode="outlined"
                type="default"
              />
            )}
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
export default React.memo(UserTableList);
